export class ProviderAttributeModel {
  ID: number;
  Name: string;
  Value: string;
  IsEncrypted: boolean;
  IsRequired: boolean;
}
